import LotteryConfigurationResponse, {
  LotteryType,
} from '@tootsweet/model/lottery/LotteryConfigurationResponse'
import { tt } from '../../i18n'
import React from 'react'
import { renderScratchCardTitle } from './renderScratchCardTitle'

export const renderTitle = (
  isPlayStep?: boolean,
  isWheel?: boolean,
  lotteryConfig?: LotteryConfigurationResponse
) => {
  if (isPlayStep) {
    if (lotteryConfig?.type === LotteryType.ScratchCard) {
      return renderScratchCardTitle(
        lotteryConfig?.scTitle || (
          <>
            {tt('its_all_good')}
            <br />
            <span className="highlight">{tt('good_luck')}</span>
          </>
        )
      )
    }
    return (
      <h2 className="h2 cm-pad" style={{ flex: 1 }}>
        {tt('its_all_good')}
        <br />
        <span className="highlight">{tt('good_luck')}</span>
      </h2>
    )
  }
  if (lotteryConfig?.type === LotteryType.ScratchCard) {
    if (lotteryConfig?.scTitle) {
      return renderScratchCardTitle(lotteryConfig.scTitle)
    }
    let text1 = lotteryConfig?.sc1
      ? tt('scratch_to_discover_1_1_card')
      : tt('scratch_to_discover_1')
    let text2 = lotteryConfig?.sc1
      ? tt('scratch_to_discover_2_1_card')
      : tt('scratch_to_discover_2')
    return renderScratchCardTitle(
      <>
        {text1}
        <br />
        <span className="highlight">{text2}</span>
      </>
    )
  }

  return (
    <h2 className="h2 cm-pad" id="lot-p-4">
      {tt('spin_to_discover_1')}
      <br />
      <span className="highlight">{tt('spin_to_discover_2')}</span>
    </h2>
  )
}
